import { Box, Grid, useMediaQuery, Typography, type Theme } from '@mui/material';
import { ProfileAvatar } from '@care/react-component-lib';
import { JOB_TYPES } from '@/constants';

import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_archivedJobSearchResults_seoSegmentationArchivedJob as SeoSegmentationArchivedJob } from 'src/__generated__/getSearchResults';
import ReadMore from '../ReadMore';

interface ArchivedJobSearchResultProps {
  job: SeoSegmentationArchivedJob;
}

const ArchivedJobSearchResult = ({ job }: ArchivedJobSearchResultProps) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const { description, title, type } = job;

  const profileAvatarProps = {
    alt: `Photo for seeker`,
    size: isMobileOrSmaller ? 'large' : 'xLarge',
    src: '',
  } as const;

  const getElongatedTitle = () => {
    const defaultText = 'About who needs care: ';
    const initialDescription = description.includes(defaultText)
      ? description.slice(defaultText.length)
      : description;

    return `${title} - ${initialDescription}`.slice(0, 65).concat('...');
  };

  const elongatedTitle = getElongatedTitle();
  return (
    <Grid item xs={12}>
      <Box display="flex">
        <ProfileAvatar {...profileAvatarProps} />
        <Box ml={2}>
          <Typography variant="h3" color="primary">
            <Box
              mb={0.5}
              sx={(theme: Theme) => ({
                overflow: 'hidden',
                display: '-webkit-box',
                '-webkit-line-clamp': 2,
                '-webkit-box-orient': 'vertical',
                [theme.breakpoints.up('sm')]: {
                  '-webkit-line-clamp': 1,
                },
              })}>
              {elongatedTitle}
            </Box>
          </Typography>
          <Typography
            variant="h5"
            color="primary"
            sx={(theme: Theme) => ({
              fontSize: { md: theme.typography.h4.fontSize },
            })}>
            <Box mb={1}>{type ? JOB_TYPES[type] : ''}</Box>
          </Typography>
          <ReadMore
            gutterBottom
            color="textPrimary"
            component="div"
            variant={isMobileOrSmaller ? 'body3' : 'body2'}
            charLimit={140}
            value={description}
            showMoreLabel="more"
            onClick={(e: { preventDefault: () => any }) => e.preventDefault()}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default ArchivedJobSearchResult;
